{
    "Profile_Residents_CriminalConviction.criminalConviction": "FR: Criminal Conviction",
    "Profile_Residents_CriminalConviction.criminalConvictionDetails": "FR: Criminal Conviction Details",
    "Profile_Residents_CriminalConviction.dateOfConviction": "FR: Date of Conviction",
    "Profile_Residents_CriminalConviction.convictionReason": "FR: Conviction Reason"
}
